export default {
  lang: 'es',
  dir: 'ltr',
  common: {
    ok: 'OK',
    cancel: 'Cancelar',
    key_backspace: 'retroceso',
    key_del: 'suprimir',
    key_down: 'abajo',
    key_up: 'arriba',
    more_opts: 'More Options',
    url: 'URL',
    width: 'Width',
    height: 'Height'
  },
  misc: {
    powered_by: 'Powered by'
  },
  ui: {
    toggle_stroke_tools: 'Mostrar/ocultar herramientas de trazo adicionales',
    palette_info: 'Haga clic para cambiar el color de relleno. Pulse Mayús y haga clic para cambiar el color del contorno.',
    zoom_level: 'Cambiar el nivel de zoom',
    panel_action: 'Click to open side panel',
    quality: 'Quality:',
    pathNodeTooltip: 'Drag node to move it. Double-click node to change segment type',
    pathCtrlPtTooltip: 'Drag control point to adjust curve properties',
    pick_stroke_paint_opacity: 'Pick a Stroke Paint and Opacity',
    pick_fill_paint_opacity: 'Pick a Fill Paint and Opacity',
    group_identify_label: 'Group identification label',
    export_type_label: 'Select an image type for export:'
  },
  properties: {
    id: 'Identify the element',
    fill_color: 'Cambiar el color de relleno',
    stroke_color: 'Cambiar el color del contorno',
    stroke_style: 'Cambiar el estilo del trazo del contorno',
    stroke_width: 'Cambiar el grosor del contorno',
    pos_x: 'Cambiar la posición horizontal X',
    pos_y: 'Cambiar la posición vertical Y',
    linecap_butt: 'Final de la línea: en el nodo',
    linecap_round: 'Final de la línea: redondeada',
    linecap_square: 'Final de la línea: cuadrada',
    linejoin_bevel: 'Unión: biselada',
    linejoin_miter: 'Unión: recta',
    linejoin_round: 'Unión: redondeada',
    angle: 'Cambiar ángulo de rotación',
    blur: 'Ajustar desenfoque gausiano',
    opacity: 'Cambiar la opacidad del objeto seleccionado',
    circle_cx: 'Cambiar la posición horizonral CX del círculo',
    circle_cy: 'Cambiar la posición vertical CY del círculo',
    circle_r: 'Cambiar el radio del círculo',
    ellipse_cx: 'Cambiar la posición horizontal CX de la elipse',
    ellipse_cy: 'Cambiar la posición vertical CY de la elipse',
    ellipse_rx: 'Cambiar el radio horizontal X de la elipse',
    ellipse_ry: 'Cambiar el radio vertical Y de la elipse',
    line_x1: 'Cambiar la posición horizontal X del comienzo de la línea',
    line_x2: 'Cambiar la posición horizontal X del final de la línea',
    line_y1: 'Cambiar la posición vertical Y del comienzo de la línea',
    line_y2: 'Cambiar la posición vertical Y del final de la línea',
    rect_height: 'Cambiar la altura del rectángulo',
    rect_width: 'Cambiar el ancho rectángulo',
    corner_radius: 'Cambiar el radio de las esquinas del rectángulo',
    image_width: 'Cambiar el ancho de la imagen',
    image_height: 'Cambiar la altura de la imagen',
    image_url: 'Modificar URL',
    node_x: 'Cambiar la posición horizontal X del nodo',
    node_y: 'Cambiar la posición vertical Y del nodo',
    seg_type: 'Cambiar el tipo de segmento',
    straight_segments: 'Recta',
    curve_segments: 'Curva',
    text_contents: 'Modificar el texto',
    font_family_label: 'Font:',
    font_family: 'Tipo de fuente',
    font_size: 'Tamaño de la fuente',
    bold: 'Texto en negrita',
    text_decoration_underline: 'Underline',
    text_decoration_linethrough: 'Line-Through',
    text_decoration_overline: 'Overline',
    italic: 'Texto en cursiva',
    text_anchor_start: 'Align the text in start',
    text_anchor_middle: 'Align the text in middle',
    text_anchor_end: 'Align the text in end',
    text_letter_spacing: 'Change the letter spacing',
    text_word_spacing: 'Change the word spacing',
    text_length: 'Lets you specify the width of the space into which the text will draw',
    text_length_adjust: 'Length adjust',
    text_length_adjust_spacing: 'Spacing',
    text_length_adjust_spacing_and_glyphs: 'Spacing & Glyphs',
    class: 'Element class',
    serif: 'Serif',
    sans_serif: 'Sans-serif',
    cursive: 'Cursive',
    fantasy: 'Fantasy',
    monospace: 'Monospace',
    courier: 'Courier',
    helvetica: 'Helvetica',
    times: 'times',
    prefs_and_content: 'Store preferences and SVG content locally',
    prefs_only: 'Only store preferences locally',
    no_prefs_or_content: 'Do not store my preferences or SVG content locally',
    jgraduate_pad: 'Pad',
    jgraduate_reflect: 'Reflect',
    jgraduate_repeat: 'Repeat'
  },
  tools: {
    main_menu: 'Menú principal',
    bkgnd_color_opac: 'Cambiar color de fondo / opacidad',
    connector_no_arrow: 'Sin flecha',
    fitToContent: 'Ajustar al contenido',
    fit_to_all: 'Ajustar a todo el contenido',
    fit_to_canvas: 'Ajustar al lienzo',
    fit_to_layer_content: 'Ajustar al contenido de la capa',
    fit_to_sel: 'Ajustar a la selección',
    align_relative_to: 'Alinear con respecto a ...',
    relativeTo: 'en relación con:',
    page: 'Página',
    largest_object: 'El objeto más grande',
    selected_objects: 'Objetos seleccionados',
    smallest_object: 'El objeto más pequeño',
    new_doc: 'Nueva imagen',
    open_doc: 'Abrir imagen',
    export_img: 'Export',
    save_doc: 'Guardar imagen',
    import_doc: 'Importar un archivo SVG',
    align_to_page: 'Align Element to Page',
    align_bottom: 'Alinear parte inferior',
    align_center: 'Centrar verticalmente',
    align_left: 'Alinear lado izquierdo',
    align_middle: 'Centrar horizontalmente',
    align_right: 'Alinear lado derecho',
    align_top: 'Alinear parte superior',
    mode_select: 'Herramienta de selección',
    mode_fhpath: 'Herramienta de lápiz',
    mode_line: 'Trazado de líneas',
    mode_rect: 'Rectangle Tool',
    mode_square: 'Square Tool',
    mode_fhrect: 'Rectángulo a mano alzada',
    mode_ellipse: 'Elipse',
    mode_circle: 'Círculo',
    mode_fhellipse: 'Elipse a mano alzada',
    mode_path: 'Herramienta de trazado',
    mode_text: 'Insertar texto',
    mode_image: 'Insertar imagen',
    mode_zoom: 'Zoom',
    no_embed: 'NOTA: La imagen no puede ser integrada. El contenido mostrado dependerá de la imagen ubicada en esta ruta. ',
    undo: 'Deshacer',
    redo: 'Rehacer',
    tool_source: 'Editar código fuente',
    wireframe_mode: 'Modo marco de alambre',
    clone: 'Clone Element(s)',
    del: 'Delete Element(s)',
    group_elements: 'Agrupar objetos',
    make_link: 'Make (hyper)link',
    set_link_url: 'Set link URL (leave empty to remove)',
    to_path: 'Convertir a trazado',
    reorient_path: 'Reorientar el trazado',
    ungroup: 'Desagrupar objetos',
    docprops: 'Propiedades del documento',
    editor_homepage: 'SVG-Edit Home Page',
    move_bottom: 'Mover abajo',
    move_top: 'Mover arriba',
    node_clone: 'Clonar nodo',
    node_delete: 'Suprimir nodo',
    node_link: 'Enlazar puntos de control',
    add_subpath: 'Añadir subtrazado',
    openclose_path: 'Open/close sub-path',
    source_save: 'Aplicar cambios',
    cut: 'Cut',
    copy: 'Copy',
    paste: 'Paste',
    paste_in_place: 'Paste in Place',
    delete: 'Delete',
    group: 'Group',
    move_front: 'Bring to Front',
    move_up: 'Bring Forward',
    move_down: 'Send Backward',
    move_back: 'Send to Back',
    tool_unlink_use: 'Break link to reference element (make unique)',
    ellipse_circle_tool: 'Ellipse/Circle Tool',
    square_rect_tool: 'Square/Rect Tool',
    remember_this_choice: 'Remember this choice?',
    remember_this_choice_title: 'If you choose to opt out of storage while remembering this choice, the URL will change so as to avoid asking again.'
  },
  layers: {
    layer: 'Capa',
    layers: 'Layers',
    del: 'Suprimir capa',
    move_down: 'Mover la capa hacia abajo',
    new: 'Nueva capa',
    rename: 'Renombrar capa',
    move_up: 'Mover la capa hacia arriba',
    dupe: 'Duplicate Layer',
    merge_down: 'Merge Down',
    merge_all: 'Merge All',
    move_elems_to: 'Desplazar objetos a:',
    move_selected: 'Mover los objetos seleccionados a otra capa'
  },
  config: {
    image_props: 'Propiedades de la Imagen',
    doc_title: 'Título',
    doc_dims: 'Tamaño del lienzo',
    included_images: 'Imágenes integradas',
    image_opt_embed: 'Integrar imágenes en forma de datos (archivos locales)',
    image_opt_ref: 'Usar la referencia del archivo',
    editor_prefs: 'Preferencias del Editor',
    language: 'Idioma',
    background: 'Fondo del editor',
    editor_img_url: 'Image URL',
    editor_bg_note: 'Nota: El fondo no se guardará junto con la imagen.',
    select_predefined: 'Seleccionar predefinido:',
    units_and_rulers: 'Units & Rulers',
    show_rulers: 'Show rulers',
    base_unit: 'Base Unit:',
    grid: 'Grid',
    snapping_onoff: 'Snapping on/off',
    snapping_stepsize: 'Snapping Step-Size:',
    grid_color: 'Grid color',
    done: 'Done',
    change_xxx_color: 'Change xxx color',
    pick_paint_opavity: 'Pick a {{newValue}} Paint and Opacity',
    open_color_picker: 'Click To Open Color Picker',
    jpicker_title: 'Drag Markers To Pick A Color',
    jpicker_new_color: 'new',
    jpicker_current_color: 'current',
    jpicker_tooltip_colors_new_color: 'New Color - Press &ldquo;OK&rdquo; To Commit',
    jpicker_tooltip_colors_current_color: 'Click To Revert To Original Color',
    jpicker_tooltip_buttons_ok: 'Commit To This Color Selection',
    jpicker_tooltip_buttons_cancel: 'Cancel And Revert To Original Color',
    jpicker_tooltip_hue_radio: 'Set To &ldquo;Hue&rdquo; Color Mode',
    jpicker_tooltip_hue_textbox: 'Enter A &ldquo;Hue&rdquo; Value (0-360&deg;)',
    jpicker_tooltip_saturation_radio: 'Set To &ldquo;Saturation&rdquo; Color Mode',
    jpicker_tooltip_saturation_textbox: 'Enter A &ldquo;Saturation&rdquo; Value (0-100%)',
    jpicker_tooltip_value_radio: 'Set To &ldquo;Value&rdquo; Color Mode',
    jpicker_tooltip_value_textbox: 'Enter A &ldquo;Value&rdquo; Value (0-100%)',
    jpicker_tooltip_red_radio: 'Set To &ldquo;Red&rdquo; Color Mode',
    jpicker_tooltip_red_textbox: 'Enter A &ldquo;Red&rdquo; Value (0-255)',
    jpicker_tooltip_green_radio: 'Set To &ldquo;Green&rdquo; Color Mode',
    jpicker_tooltip_green_textbox: 'Enter A &ldquo;Green&rdquo; Value (0-255)',
    jpicker_tooltip_blue_radio: 'Set To &ldquo;Blue&rdquo; Color Mode',
    jpicker_tooltip_blue_textbox: 'Enter A &ldquo;Blue&rdquo; Value (0-255)',
    jpicker_tooltip_alpha_radio: 'Set To &ldquo;Alpha&rdquo; Color Mode',
    jpicker_tooltip_alpha_textbox: 'Enter A &ldquo;Alpha&rdquo; Value (0-100)',
    jpicker_tooltip_hex_textbox: 'Enter A &ldquo;Hex&rdquo; Color Value (#000000-#ffffff)',
    jpicker_tooltip_hex_alpha: 'Enter A &ldquo;Alpha&rdquo; Value (#00-#ff)',
    jgraduate_solid_color: 'Solid Color',
    jgraduate_linear_gradient: 'Linear Gradient',
    jgraduate_radial_gradient: 'Radial Gradient',
    jgraduate_begin_point: 'Begin Point',
    jgraduate_enter_starting_x: 'Enter starting x value between 0.0 and 1.0',
    jgraduate_enter_starting_y: 'Enter starting y value between 0.0 and 1.0',
    jgraduate_end_point: 'End Point',
    jgraduate_enter_ending_x: 'Enter ending x value between 0.0 and 1.0',
    jgraduate_enter_ending_y: 'Enter ending y value between 0.0 and 1.0',
    jgraduate_center_point: 'Center Point',
    jgraduate_enter_value_x: 'Enter x value between 0.0 and 1.0',
    jgraduate_enter_value_y: 'Enter y value between 0.0 and 1.0',
    jgraduate_focal_point: 'Focal Point',
    jgraduate_match_center: 'Match center:',
    jgraduate_enter_focal_x: 'Enter x value between 0.0 and 1.0',
    jgraduate_enter_focal_y: 'Enter y value between 0.0 and 1.0',
    jgraduate_spread_method: 'Spread method',
    jgraduate_radius: 'Radius:',
    jgraduate_set_radius: 'Click to set radius',
    jgraduate_ellip: 'Ellip:',
    jgraduate_set_ellip: 'Click to set Ellip',
    jgraduate_angle: 'Angle:',
    jgraduate_set_angle: 'Click to set Angle',
    jgraduate_deg: 'deg:',
    jgraduate_opac: 'Opac:',
    jgraduate_set_opac: 'Click to set Opac'
  },
  notification: {
    invalidAttrValGiven: 'Valor no válido',
    noContentToFitTo: 'No existe un contenido al que ajustarse.',
    dupeLayerName: '¡Ya existe una capa con este nombre!',
    enterUniqueLayerName: 'Introduzca otro nombre distinto para la capa.',
    enterNewLayerName: 'Introduzca el nuevo nombre de la capa.',
    layerHasThatName: 'El nombre introducido es el nombre actual de la capa.',
    QmoveElemsToLayer: "¿Desplazar los elementos seleccionados a la capa '%s'?",
    QwantToClear: '¿Desea borrar el dibujo?\n¡El historial de acciones también se borrará!',
    QwantToOpen: 'Do you want to open a new file?\nThis will also erase your undo history!',
    QerrorsRevertToSource: 'Existen errores sintácticos en su código fuente SVG.\n¿Desea volver al código fuente SVG original?',
    QignoreSourceChanges: '¿Desea ignorar los cambios realizados sobre el código fuente SVG?',
    featNotSupported: 'Función no compatible.',
    enterNewImgURL: 'Introduzca la nueva URL de la imagen.',
    defsFailOnSave: 'NOTA: Debido a un fallo de su navegador, es posible que la imagen aparezca de forma incorrecta (ciertas gradaciones o elementos podría perderse). La imagen aparecerá en su forma correcta una vez guardada.',
    loadingImage: 'Cargando imagen. Espere, por favor.',
    saveFromBrowser: "Select 'Save As...' in your browser (possibly via file menu or right-click context-menu) to save this image as a {{type}} file.",
    noteTheseIssues: 'Existen además los problemas siguientes:',
    unsavedChanges: 'There are unsaved changes.',
    enterNewLinkURL: 'Enter the new hyperlink URL',
    errorLoadingSVG: 'Error: Unable to load SVG data',
    URLLoadFail: 'Unable to load from URL',
    retrieving: "Retrieving '%s' ...",
    popupWindowBlocked: 'Popup window may be blocked by browser',
    exportNoBlur: 'Blurred elements will appear as un-blurred',
    exportNoforeignObject: 'foreignObject elements will not appear',
    exportNoDashArray: 'Strokes will appear filled',
    exportNoText: 'Text may not appear as expected',
    editorPreferencesMsg: 'By default and where supported, SVG-Edit can store your editor preferences and SVG content locally on your machine so you do not need to add these back each time you load SVG-Edit. If, for privacy reasons, you do not wish to store this information on your machine, you can change away from the default option below.',
    source_dialog_note: 'Copy the contents of this box into a text editor, then save the file with a .svg extension.'
  }
}
